import { callPost } from '../graphql';
import { ME } from '../graphql/query';

export const getMe = async (token?: string) => {
    const { data: axiosData } = await callPost(ME, {}, token);
    const { data } = axiosData;
    return data.me;
};
